module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"step":"interview questions list","back":"Back","next":"Next","special":"Let\u0027s ask the candidate some questions about their professional specialization","select":"Select specialization or find question by keyword"}}')
  delete Component.options._Ctor
}
